import {
  REPLACE_TIMELINE,
  ReplaceTimelineAction,
  TimelineItem,
  UPDATE_TIMELINE,
  UpdateTimelineAction,
} from "./types";

export const updateTimelineAction = (
  items: TimelineItem[],
  id: string,
  targetTimestamp: number,
  cleanupAmount: number | undefined,
  nextChunkRequestTimestamp: number
): UpdateTimelineAction => {
  return {
    type: UPDATE_TIMELINE,
    payload: {
      id,
      items,
      cleanupAmount,
      targetTimestamp,
      nextChunkRequestTimestamp,
    },
  };
};

export const replaceTimelineAction = (
  items: TimelineItem[],
  id: string,
  targetTimestamp: number,
  nextChunkRequestTimestamp: number
): ReplaceTimelineAction => {
  return {
    type: REPLACE_TIMELINE,
    payload: {
      id,
      items,
      targetTimestamp,
      nextChunkRequestTimestamp,
    },
  };
};
